import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';

// project-imports
import { clacUiGlobal as ui } from 'utils/uiGlobal';
import { APP_VERSION_LABEL } from 'utils/appVersion';

// ==============================|| LOGO PRINCIPAL — .sidebar-brand del shell ||============================== //

export default function LogoMain() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5, minWidth: 0 }}>
      <Box
        sx={{
          bgcolor: ui.semantic.bg.surface,
          border: `1px solid ${ui.semantic.border.subtle}`,
          borderRadius: ui.radius.md,
          px: 1,
          py: 0.75,
          lineHeight: 0,
          flexShrink: 0,
          boxShadow: ui.shadow.card
        }}
      >
        <Box component="img" src="/clac_logo.png" alt="CLAC Logo" sx={{ height: 30, width: 'auto', display: 'block' }} />
      </Box>
      <Stack sx={{ minWidth: 0, gap: '2px', overflow: 'hidden' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
          <Typography
            sx={{
              fontFamily: ui.fonts.families.heading,
              fontSize: ui.fonts.sizes.md,
              fontWeight: ui.fonts.weights.extrabold,
              color: ui.semantic.text.primary,
              lineHeight: 1.15
            }}
          >
            <FormattedMessage id="app.brand.title" />
          </Typography>
          <Box
            component="span"
            sx={{
              bgcolor: ui.semantic.brand.bg,
              color: ui.semantic.brand.dark,
              border: `1px solid ${ui.semantic.brand.border}`,
              fontSize: ui.fonts.sizes['4xs'],
              fontWeight: ui.fonts.weights.bold,
              letterSpacing: '0.02em',
              borderRadius: ui.radius.pill,
              px: '7px',
              py: '2px',
              lineHeight: 1.4,
              flexShrink: 0
            }}
          >
            {APP_VERSION_LABEL}
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: ui.fonts.sizes['2xs'],
            fontWeight: ui.fonts.weights.regular,
            color: ui.semantic.text.muted,
            lineHeight: 1.3,
            whiteSpace: 'nowrap'
          }}
        >
          <FormattedMessage id="app.brand.subtitle" />
        </Typography>
      </Stack>
    </Stack>
  );
}
